import { DBSchema, openDB } from "idb";
import { LoginResponse } from "./api/login";

export interface PersistenceStorageAdapter {
  get(): Promise<LoginResponse | undefined>;
  set(val: LoginResponse): Promise<void>;
  clear(): Promise<void>;
}

interface PersistenceDatabase extends DBSchema {
  persistence: {
    value: LoginResponse;
    key: "auth";
  };
}

// Only create connectors on client-side or in test environments to avoid SSR issues
const dbPromise =
  typeof window !== "undefined" || process.env.VITEST === "true"
    ? openDB<PersistenceDatabase>("persistence-store", 1, {
        upgrade(db) {
          db.createObjectStore("persistence");
        },
      })
    : Promise.resolve(null);

const get = async (key: "auth") => {
  return (await dbPromise)?.get("persistence", key);
};
const set = async (key: "auth", val: LoginResponse) => {
  return (await dbPromise)?.put("persistence", val, key);
};
const clear = async (key: "auth") => {
  return (await dbPromise)?.delete("persistence", key);
};

export const persistenceDatabase = {
  get,
  set,
  clear,
};

export const defaultStorageAdapter: PersistenceStorageAdapter = {
  get: async () => get("auth"),
  set: async (val: LoginResponse) => {
    await set("auth", val);
  },
  clear: async () => {
    await clear("auth");
  },
};
